export default __webpack_public_path__ + "images/CI.d463a0a.png";